module.exports = __webpack_public_path__ + "img/solar-panel-dark.d2346e31.png";